export default {
  // Hero
  aboutHeroTag: "About AIP",
  aboutHeroTitle1: "Trusted Partner for",
  aboutHeroTitle2: "Business in East Africa",
  aboutHeroDesc: "Africa Investment Portal (AIP) is a premier business facilitation firm based in Kigali, Rwanda, specializing in market entry, regulatory compliance, and investment facilitation across East Africa.",

  // Story
  storyTag: "Our Story",
  storyTitle: "Simplifying Business",
  storyTitleAccent: "in East Africa",
  storyP1: "Africa Investment Portal was founded with a clear mission: to remove barriers for international businesses and investors entering East Africa's rapidly growing markets. We understood that navigating complex regulatory environments, diverse legal systems, and cultural nuances was a major challenge for foreign entities.",
  storyP2: "Today, AIP has become the go-to partner for companies seeking seamless market entry, regulatory compliance, and sustainable business growth across Rwanda, Kenya, Uganda, Tanzania, Ethiopia, Burundi, and the DRC. Our team of local experts, regulatory specialists, and investment advisors work hand-in-hand with clients to deliver results.",
  storyHQLabel: "Headquartered in",
  storyHQCity: "Kigali, Rwanda",
  storyStatFounded: "Founded",
  storyStatCountries: "Countries",
  storyStatClients: "Clients Served",

  // Mission & Vision
  missionVisionTag: "Our Values",
  missionTitle: "Our Mission",
  missionDesc: "To empower businesses and investors to successfully enter, operate, and grow in East Africa by providing expert facilitation, regulatory guidance, and strategic market access support — making East Africa's opportunity accessible to all.",
  visionTitle: "Our Vision",
  visionDesc: "To be the most trusted investment and business facilitation platform in East Africa — the bridge that connects global ambition with African opportunity, driving sustainable economic growth across the region.",
  valuesTitle: "What Drives Us",
  valueIntegrityTitle: "Integrity",
  valueIntegrityDesc: "We uphold the highest ethical standards in every engagement, ensuring transparency and accountability.",
  valueExcellenceTitle: "Excellence",
  valueExcellenceDesc: "We deliver exceptional quality in all our services, continuously raising the bar for our clients.",
  valuePartnershipTitle: "Partnership",
  valuePartnershipDesc: "We build lasting relationships, treating every client's success as our own mission.",
  valueEfficiencyTitle: "Efficiency",
  valueEfficiencyDesc: "We move fast and solve problems, ensuring businesses get results without unnecessary delays.",

  // Team
  teamTag: "Leadership",
  teamTitle: "Meet Our Team",
  teamDesc: "A dedicated team of East Africa specialists, regulatory experts, and investment advisors working for your success.",

  // CTA
  aboutCtaTag: "Ready to Begin?",
  aboutCtaTitle: "Let's Build Your Business",
  aboutCtaAccent: "in East Africa Together",
  aboutCtaExplore: "Explore Services",
  aboutCtaContact: "Contact Us",
};